import React from "react";

interface Photo {
  src: string;
  alt: string;
  title: string;
}

interface PhotoGalleryProps {
  photos: Photo[];
  className?: string;
}

const PhotoGallery: React.FC<PhotoGalleryProps> = ({
  photos,
  className = "",
}) => {
  return (
    <div className={`launch-gallery ${className}`}>
      <div className="row g-3">
        {photos.map((photo, index) => (
          <div key={index} className="col-lg-3 col-md-6 col-sm-6">
            <div className="gallery-item">
              <a
                href={photo.src}
                title={photo.title}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={photo.src}
                  alt={photo.alt}
                  className="img-fluid rounded"
                  loading="lazy"
                  decoding="async"
                  style={{
                    display: "block",
                    width: "100%",
                    height: "auto",
                    backfaceVisibility: "hidden",
                    WebkitBackfaceVisibility: "hidden",
                  }}
                />
                <div className="gallery-overlay">
                  <i className="fas fa-search-plus"></i>
                </div>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PhotoGallery;
